/**
 * @fileoverview Provide the native-select boundary for caller-owned form choices. Selection emits the chosen string directly; `AppDropdown.js` provides searchable selection with a value envelope. Neither component fetches choices or persists domain state.
 */

import React from 'react'

const inputStyle = {
    width: '100%',
    padding: '0.6rem 0.75rem',
    borderRadius: '6px',
    border: '1px solid var(--surface-border)',
    fontSize: '1rem',
    color: 'var(--text-color)'
}



function AppSelect({ id, value, options, placeholder, onChange, disabled, className }) {
    return (
        <select
            id={id}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            disabled={disabled}
            className={className || ''}
            style={{
                ...inputStyle,
                backgroundColor: disabled ? 'var(--surface-hover)' : 'var(--surface-section)'
            }}
        >
            {placeholder && <option value="">{placeholder}</option>}
            {options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
    )
}

export default AppSelect
